// Shared error helpers — extract a human message / HTTP status from an unknown
// caught/query error WITHOUT an `any` cast. Axios errors carry
// `response.data.error` + `response.status`; plain Errors carry `message`.
// Structural-typed casts (not `any`) keep `no-explicit-any` happy.

type ApiErrorShape = {
  response?: { data?: { error?: string }; status?: number }
  message?: string
}

export function apiError(e: unknown, fallback = 'Something went wrong'): string {
  const r = e as ApiErrorShape | null | undefined
  return r?.response?.data?.error ?? r?.message ?? fallback
}

export function errStatus(e: unknown): number | undefined {
  return (e as ApiErrorShape | null | undefined)?.response?.status
}
